import { useAppTFunction } from '@retail/app/i18n';
import { useToast } from '@retail/hooks';
import { useAssortmentItemsActions } from '@retail/my-assortment/context';
import { AssortmentItemPriorityDTO } from '@retail/my-assortment/types';
import { useCallback, useState } from 'react';

interface UseReplaceAssortmentItemProps {
  onItemReplaced: () => void;
}

export const useReplaceAssortmentItem = ({ onItemReplaced }: UseReplaceAssortmentItemProps) => {
  const t = useAppTFunction();
  const toast = useToast();

  const { addItemsToAssortment } = useAssortmentItemsActions();

  const [isSaving, setIsSaving] = useState(false);

  const replaceItem = useCallback(
    async (replacementItem: AssortmentItemPriorityDTO, replacesSupplierItemId: number) => {
      setIsSaving(true);
      try {
        await addItemsToAssortment([{ ...replacementItem, replacesSupplierItemId }], {
          skipToast: true,
        });

        toast.success(t('myAssortment.actions.itemReplaced'));
        onItemReplaced();
      } catch (e) {
        console.error(e);
        toast.error(t('products.errors.generic'));
      } finally {
        setIsSaving(false);
      }
    },
    [addItemsToAssortment, onItemReplaced, toast, t]
  );

  return { replaceItem, isSaving };
};
